/**
 * Select2 Initialization Module
 * Handles initialization of Select2 on filter selects
 */

const select2Init = {
    init: function() {
        // Only proceed if Select2 is available
        if (typeof jQuery.fn.select2 === 'undefined') {
            console.warn('Select2 not loaded');
            return;
        }

        this.initPostsFilter();
        this.initCandleFilter();
        this.initCandleFormCountry();
        this.initCF7Selects();

        // Reinitialize CF7 selects after form events
        const self = this;
        document.addEventListener('wpcf7mailsent', function() {
            self.initCF7Selects();
        });
        document.addEventListener('wpcf7invalid', function() {
            self.initCF7Selects();
        });
    },

    /**
     * Initialize Select2 for Posts Filter
     * Selectors: #filter-misto, #filter-stitek
     */
    initPostsFilter: function() {
        const $filterMisto = jQuery('#filter-misto');
        const $filterStitky = jQuery('#filter-stitek');

        const baseConfig = {
            width: '100%',
            minimumResultsForSearch: -1,
            allowClear: false
        };

        if ($filterMisto.length) {
            $filterMisto.select2({
                ...baseConfig,
                dropdownParent: $filterMisto.closest('.filter-col')
            });
        }

        if ($filterStitky.length) {
            $filterStitky.select2({
                ...baseConfig,
                dropdownParent: $filterStitky.closest('.filter-col')
            });
        }
    },

    /**
     * Initialize Select2 for Candle Country Filter
     * Selector: #countryFilter
     * Note: Auto-submits form on change
     */
    initCandleFilter: function() {
        const $countryFilter = jQuery('#countryFilter');

        if (!$countryFilter.length) {
            return;
        }

        $countryFilter.select2({
            width: '100%',
            minimumResultsForSearch: -1,
            allowClear: false,
            dropdownParent: $countryFilter.closest('.candle-filter')
        });

        // Preserve the auto-submit behavior
        $countryFilter.on('select2:select', function() {
            jQuery(this).closest('form').submit();
        });
    },

    /**
     * Initialize Select2 for Candle Form Country select
     * Selector: #country (inside #candlePersonalForm)
     */
    initCandleFormCountry: function() {
        const $countrySelect = jQuery('#candlePersonalForm #country');

        if (!$countrySelect.length) {
            return;
        }

        // Skip if Select2 is already initialized
        if ($countrySelect.hasClass('select2-hidden-accessible')) {
            return;
        }

        $countrySelect.select2({
            width: '100%',
            minimumResultsForSearch: -1,
            allowClear: false,
            dropdownParent: $countrySelect.closest('.form-group')
        });
    },

    /**
     * Initialize Select2 for Contact Form 7 selects
     * Applies to all select elements inside .wpcf7-form
     */
    initCF7Selects: function() {
        const $cf7Selects = jQuery('.wpcf7-form select');

        if (!$cf7Selects.length) {
            return;
        }

        $cf7Selects.each(function() {
            const $select = jQuery(this);

            // Skip if Select2 is already initialized
            if ($select.hasClass('select2-hidden-accessible')) {
                return;
            }

            $select.select2({
                width: '100%',
                minimumResultsForSearch: -1,
                allowClear: false,
                dropdownParent: $select.closest('.wpcf7-form-control-wrap')
            });
        });
    },

    /**
     * Clear Select2 selections (for reset functionality)
     */
    clearSelections: function() {
        jQuery('#filter-misto, #filter-stitek, #countryFilter').val('').trigger('change');
    }
};

export { select2Init };
